




















































import { pickBy, every } from 'lodash'
import { Icon } from '@alpha/ink'
import ImagePicker from './ImagePicker.vue'
import ExistingAssetPicker from './ExistingAssetPicker.vue'
import { Vue, Component, Prop } from 'vue-property-decorator'
import * as db from '@shared/types/database'
import icoLookup from '@/utilities/ico-lookup'

@Component({
  components: {
    Icon,
    ImagePicker,
    ExistingAssetPicker
  }
})
export default class ImageComparison extends Vue {
  @Prop({ required: true }) list!: Record<string, db.Prototype>
  @Prop({ default: () => ({}) }) assets!: Record<string, db.Prototype>
  @Prop({ default: 1 }) minLength!: number
  @Prop({ default: 4 }) maxLength!: number
  @Prop({ default: false }) editable!: boolean

  focused: number | false = false

  get selectableAssets () {
    var k = pickBy(this.assets, (value, key) => {
      return every(this.list, (chosenAsset, idx) => {
        return idx !== key
      })
    })
    return k
  }

  get imageTypeMap () {
    return icoLookup
  }

  onFocus (index: number) {
    this.focused = index
  }

  onBlur (event: FocusEvent) {
    if (typeof this.focused !== 'number') return
    const focusedEl = (this.$refs.proto as Element[])[this.focused]
    if (focusedEl.contains(event.relatedTarget as Element)) {
      this.focused = false
    }
  }

  focusAsset () {
    var that = this
    this.$nextTick(function () {
      var focusRef = 'proto-title'
      const focusedEls = that.$refs[focusRef] as Element[]
      const lastIndex = focusedEls.length - 1
      const input = focusedEls[lastIndex] as HTMLInputElement
      that.focused = lastIndex
      input.focus()
      that.$forceUpdate()
    })
  }

  removeOption (key: string) {
    this.$emit('removeOption', key)
  }

  selectExistingAsset (asset: db.Prototype, ts: number) {
    var assetClone = Object.assign({}, asset)
    this.$set(this.list, ts, assetClone)
  }

  addNewAsset (asset: db.Prototype) {
    var ts = +new Date()
    this.selectExistingAsset(asset, ts)
  }

  openInNewWindow (asset: db.Prototype, event?: Event) {
    event && event.stopPropagation()
    window.open(asset.url!)
  }

  clickItem (asset: db.Prototype) {
    if (!this.editable) {
      this.openInNewWindow(asset)
    }
  }
}
